// @import

import { ensureHTMLElement, ensureHTMLNodeList } from "@src/js/lib/ensure";
import { viewport } from "@src/js/lib/viewport";
import Alpine from "alpinejs";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

Alpine.directive("header", (element, _, { cleanup, effect }) => {
  let isOpen = false;
  let hasInitMobile = false;

  const dom = {
    panels: ensureHTMLNodeList(element.querySelectorAll(".c-submenu")),
    burgerButton: ensureHTMLElement(element.querySelector(".c-burger")),
    backButton: ensureHTMLElement(element.querySelector(".c-header__back-button")),
    panelTriggers: ensureHTMLNodeList(element.querySelectorAll(".js-panel-trigger")),
  };

  function toggleMobile() {
    const classMethod = isOpen ? "remove" : "add";
    element.classList[classMethod]("c-header--mobile-open");
    dom.burgerButton.classList[classMethod]("c-burger--open");
    document.body.style.overflow = isOpen ? "visible" : "hidden";
    isOpen && setTimeout(closeMobileSubMenu, 400);
    isOpen = !isOpen;
  }

  function toggleMobileSubMenu(event: MouseEvent) {
    const target = event.currentTarget as HTMLElement;
    const panel = target.querySelector(".c-submenu");
    if (!panel) return;
    event.preventDefault();
    unbindSubMenuTriggers();
    panel.classList.toggle("c-submenu--mobile-open");
  }

  function closeMobileSubMenu() {
    dom.panels.forEach((panel) => {
      panel.classList.remove("c-submenu--mobile-open");
    });
    bindSubMenuTriggers();
  }

  function bindSubMenuTriggers() {
    dom.panelTriggers.forEach((button) => {
      button.addEventListener("click", toggleMobileSubMenu);
    });
  }
  function unbindSubMenuTriggers() {
    dom.panelTriggers.forEach((button) => {
      button.removeEventListener("click", toggleMobileSubMenu);
    });
  }

  function bindMobile() {
    dom.burgerButton.addEventListener("click", toggleMobile);
    dom.backButton.addEventListener("click", closeMobileSubMenu);
    bindSubMenuTriggers();
    hasInitMobile = true;
  }

  function unbindMobile() {
    dom.burgerButton.removeEventListener("click", toggleMobile);
    dom.backButton.removeEventListener("click", closeMobileSubMenu);
    unbindSubMenuTriggers();
    hasInitMobile = false;
  }

  effect(() => {
    if (viewport.width < 1024 && !hasInitMobile) {
      bindMobile();
    }
  });

  effect(() => {
    if (viewport.width >= 1024 && hasInitMobile) {
      unbindMobile();
    }
  });

  effect(() => {
    if (viewport.width >= 1024 && isOpen) {
      toggleMobile();
    }
  });

  cleanup(() => {
    unbindMobile();
  });
});
